// extracted by mini-css-extract-plugin
export default {"homeWrapper":"HomePage_homeWrapper__xrWu4"};